/** @hidden */
export abstract class IgxInputGroupBase {
    disabled: boolean;
    isFocused: boolean;
    isRequired: boolean;
    hasPlaceholder: boolean;
}
